const BASE = "$appbase";

export const MODAL_CURRENT = `${BASE}/modal`;
export const USERCARD_CURRENT = `${BASE}/userCard`;
export const PAGE_CURRENT = `${BASE}/page/info`;
export const TEAMS = `${BASE}/teams`;

export const FILE_UPLOADING = `eum-file-uploading`;
export const LOADING_BAR_MESSAGE = `${BASE}/loading-bar-message`;
